export enum Accounts {
    'OFFICE' = 'ACCOUNTS-OFFICE',
    'DEPARTMENT' = 'ACCOUNTS-DEPARTMENT',
    'EFFECTIVE_DATE' = 'EFFECTIVE_DATE',
    'REC_STATUS' = 'ACCOUNTS-REC_STATUS',
    'PROFILE_CHANGE_STATUS' = 'ACCOUNTS-PROFILE_CHANGE_STATUS',
    'CURRENCY' = 'ACCOUNTS-CURRENCY',
    'TIME_STAMP' = 'TIME_STAMP',
    'UID' = 'VIRTUAL-UID',
    'PROFILE_UPDATE_PK' = 'PROFILE_UPDATE_PK',
    'PU_TIME_STAMP' = 'PU_TIME_STAMP',
    'NOTE' = 'NOTE'
};
